import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const availableLangs = process.env.REACT_APP_DEFAULT_LANG_LIST.split(',');

i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
    fallbackLng: availableLangs,
    interpolation: {
        escapeValue: false, 
    }
});

export default i18n;